import _flatMap from 'lodash-es/flatMap';
import _groupBy from 'lodash-es/groupBy';
import _mapKeys from 'lodash-es/mapKeys';
import _mapValues from 'lodash-es/mapValues';
import _uniqBy from 'lodash-es/uniqBy';

import { SectionMap } from 'Types/Rooms';

import {
  LOADED_ROOMS,
  LOADING_ROOMS,
  LOAD_ROOMS_FAILED,
  LOADING_ROOM_INFO,
  LOADED_ROOM_INFO,
  LOAD_ROOM_INFO_FAILED,
  RoomsAction
} from './Actions';

export interface RoomsState {
  itemsById: _.Dictionary<TrykApi.Catalog.IRoomScene>;
  brandDefaultIdMap: _.Dictionary<number>;
  brandMap: _.Dictionary<number[]>;
  sectionMap: SectionMap;
  categories: TrykApi.Catalog.IRoomSceneCategory[];
  loading: boolean;
  loaded: boolean;
  failed: boolean;
  roomInfoErrorsById: _.Dictionary<boolean>;
  roomInfoLoadingById: _.Dictionary<boolean>;
  roomInfoById: _.Dictionary<TrykApi.Images.IRoomInfo>;
}

const initialState: RoomsState = {
  itemsById: {},
  brandDefaultIdMap: {},
  brandMap: {},
  sectionMap: {},
  categories: [],
  loading: false,
  loaded: false,
  failed: false,
  roomInfoErrorsById: {},
  roomInfoLoadingById: {},
  roomInfoById: {},
};

function roomsReducer(state = initialState, action: RoomsAction): RoomsState {
  switch (action.type) {
    case LOADED_ROOMS:
      return {
        itemsById: _mapKeys(
          _uniqBy(
            _flatMap(action.items, x => x.roomScenes),
            x => x.roomId
          ),
          x => x.roomId
        ),
        brandDefaultIdMap: _mapValues(
          _groupBy(action.items, 'brandId'),
          grp => _flatMap(grp, x => x.roomScenes.map(y => y)).filter(x => x.isDefault).map(x => x.roomId)[0] ||
            (grp[0].roomScenes[0] || { roomId: 0 }).roomId
        ),
        brandMap: _mapValues(
          _groupBy(action.items, 'brandId'),
          grp => _flatMap(grp, x => x.roomScenes.map(y => y.roomId))
        ),
        sectionMap: action?.sectionMap || {},
        loaded: true,
        loading: false,
        failed: false,
        categories: action?.categories || [],
        roomInfoErrorsById: state.roomInfoErrorsById,
        roomInfoLoadingById: state.roomInfoLoadingById,
        roomInfoById: state.roomInfoById,
      };
    case LOADING_ROOMS:
      return {
        itemsById: {},
        brandDefaultIdMap: {},
        brandMap: {},
        sectionMap: {},
        categories: [],
        loading: true,
        loaded: false,
        failed: false,
        roomInfoErrorsById: {},
        roomInfoLoadingById: {},
        roomInfoById: {},
      };
    case LOAD_ROOMS_FAILED:
      return {
        itemsById: {},
        brandDefaultIdMap: {},
        brandMap: {},
        sectionMap: {},
        categories: [],
        loading: false,
        loaded: false,
        failed: true,
        roomInfoErrorsById: {},
        roomInfoLoadingById: {},
        roomInfoById: {},
      };
    case LOADING_ROOM_INFO:
      if (action?.roomId) {
        return {
          ...state,
          roomInfoLoadingById: {
            ...state.roomInfoLoadingById,
            [action.roomId]: true
          },
          roomInfoErrorsById: {
            ...state.roomInfoErrorsById,
            [action.roomId]: false
          }
        };
      } else {
        return state;
      }
    case LOAD_ROOM_INFO_FAILED:
      if (action?.roomId) {
        return {
          ...state,
          roomInfoLoadingById: {
            ...state.roomInfoLoadingById,
            [action.roomId]: false
          },
          roomInfoErrorsById: {
            ...state.roomInfoErrorsById,
            [action.roomId]: true
          }
        };
      } else {
        return state;
      }
    case LOADED_ROOM_INFO:
      if (action?.roomId) {
        return {
          ...state,
          roomInfoLoadingById: {
            ...state.roomInfoLoadingById,
            [action.roomId]: false
          },
          roomInfoErrorsById: {
            ...state.roomInfoErrorsById,
            [action.roomId]: false
          },
          roomInfoById: {
            ...state.roomInfoById,
            [action.roomId]: action.roomInfo
          }
        };
      } else {
        return state;
      }
    default:
      return state;
  }
}

export default roomsReducer;
